import { ValidationErrors, AbstractControl } from '@angular/forms';
import { RootState } from '@next/core-lib/app';
import { Store, select } from '@ngrx/store';
import { of, timer, Observable } from 'rxjs';
import { switchMap, withLatestFrom, map, take } from 'rxjs/operators';

import { isDuplicateBarnName } from '../store/selectors/settings.selectors';

export const barnNameValidator =
  (store: Store<RootState>) =>
  (control: AbstractControl): Observable<ValidationErrors | null> =>
    timer(1).pipe(
      withLatestFrom(
        store.pipe(
          select(isDuplicateBarnName),
          map((f) => f(<string>control.value)),
        ),
      ),
      switchMap(([_, res]) => (res ? of(<ValidationErrors>{ duplicateBarnName: true }) : of(null))),
      take(1),
    );
